<template>
  <v-tab-transition class="d-flex justify-center" group>
    <v-card v-show="true" key="form" class="card layout column">
      <v-toolbar light class="v-toolbar elevation-0">
        <b>Create Interaction</b>
      </v-toolbar>
      <div class="pa-2">
        <div class="top container grid-list-md pa-2 justify-space-between">
          <v-layout wrap>
            <v-flex md12 xs12>
              <v-select
                v-model="type"
                persistent-hint
                hint="Choose the Interaction Type"
                :items="[
                  { internal: 'click', public: 'Click' },
                  { internal: 'swipe', public: 'Swipe' }
                ]"
                solo
                flat
                color="primary"
                dense
                item-text="public"
                item-value="internal"
                label="Interaction Type"
                single-line
              />
            </v-flex>
            <v-flex md12 xs12>
              <v-autocomplete
                v-model="slide"
                persistent-hint
                hint="Find your Slide by ID or Name or Key Message"
                :items="slides"
                :loading="isLoading"
                :search-input.sync="search"
                :filter="v => v"
                autofocus
                solo
                flat
                dense
                item-text="name"
                item-value="_id"
                label="Select Destination Slide"
                return-object
                single-line
              >
                <template v-slot:item="{ item }">
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ item.name | truncate(30) }} ({{ item.externalId }})
                    </v-list-item-title>
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-flex>
            <v-responsive v-show="slide !== null" class>
              <v-img v-if="slide" :src="slide.asset.png" />
            </v-responsive>
          </v-layout>
          <!-- <div>
                <input v-model="wildcard" @keyup="searchSlide" placeholder="External ID:" class="to-slide pa-2"/>

                <div class="slide-list"  v-show="slides.length > 0 && slides.length < 10">
                  <div class="d-flex" @click="setActive(slide)" v-ripple v-for="slide in slides" :key="slide._id">
                    <div style="max-width: 100px;" class="pa-2"><v-img v-if="slide.asset.png !== null" :src="slide.asset.png"></v-img></div>
                    <div class="pa-2 align-center">{{ slide.name }}</div>
                  </div>
                </div>
          </div>-->
        </div>

        <div class="pa-2">
          <v-textarea v-model="info" solo flat persistent-hint hint="Additional information" rows="1" />
        </div>
        <div class="pa-2">
          <v-checkbox v-model="withReturnButton" label="With Return Button" />
          <v-checkbox v-model="withPagination" label="With Pagination" />

          <v-autocomplete
            v-model="returnSlide.to"
            :filter="v => v"
            :items="slidesReturn"
            :loading="isLoading"
            :search-input.sync="searchReturnSlide"
            autofocus
            solo
            flat
            dense
            item-text="name"
            item-value="_id"
            label="Select Slide to Return To"
            return-object
            single-line
          >
            <template v-slot:item="{ item }">
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.name | truncate(30) }} ({{ item.externalId }})
                </v-list-item-title>
              </v-list-item-content>
            </template>
          </v-autocomplete>
        </div>
      </div>
      <v-spacer />
      <div class="pa-2 d-flex">
        <v-spacer />
        <v-btn depressed @click.stop="$emit('close')">
          Cancel
        </v-btn>
        <v-btn :loading="isLoading" class="ml-1" color="primary" depressed @click="action">
          Save
        </v-btn>
      </div>
    </v-card>
    <!-- <div v-show="slide !== null" class="pa-0 ml-1 img" key="slide">
          <v-fade-transition>

          </v-fade-transition>
    </div>-->
  </v-tab-transition>
</template>
<script>
// import {SlideService} from '@/services/modules/slide';
import { CREATE_INTERACTION, UPDATE_ACTIVE_INTERACTION } from '@/config/constants';
import { debounce } from 'lodash';
import { mapGetters } from 'vuex';
// const service = new SlideService();
export default {
  name: 'CreateInteractionDialog',
  props: {
    update: {
      type: Boolean,
      default: false
    },
    interaction: {
      type: Object
    }
  },
  data() {
    return {
      slide: null,
      slides: [],
      slidesReturn: [],
      type: 'click',
      wildcard: null,
      search: null,
      searchReturnSlide: null,
      withReturnButton: false,
      withPagination: false,
      isLoading: false,
      returnSlide: {
        to: null
      },
      info: ''
    };
  },
  computed: {
    ...mapGetters('slides', {
      searchSlides: 'search'
    })
  },
  watch: {
    search(val) {
      this.isLoading = true;
      this.slides = this.searchSlides(val);
      this.isLoading = false;
    },
    searchReturnSlide(val) {
      this.isLoading = true;
      this.query(val);
    }
  },
  mounted() {
    if (this.interaction) {
      this.slide = this.interaction.to.asset;
      this.slides = [this.interaction.to.asset];
      if (this.interaction.to.return.to) {
        this.slidesReturn = [this.interaction.to.return.to];
        this.returnSlide.to = this.interaction.to.return.to;
      }
      this.type = this.interaction.type;
      this.search = this.interaction.to.name;
      this.withReturnButton = this.interaction.to.withReturnButton;
      this.withPagination = this.interaction.to.withPagination;

      this.info = this.interaction.info;
    }
  },
  methods: {
    query: debounce(function(val) {
      const { SlideService } = require('@/services/modules/slide');
      new SlideService()
        .query({
          product: this.$store.state.product.selected.product._id,
          country: this.$store.state.product.selected.country,
          wildcard: val
        })
        .then(items => {
          this.slidesReturn = items.data;
          this.isLoading = false;
        })
        .catch(o => (this.isLoading = false));
    }, 200),
    setActive(slide) {
      this.slide = slide;
    },
    action() {
      switch (this.update) {
        case true:
          return this.updateInteraction();
        default:
          return this.createInteraction();
      }
    },
    updateInteraction() {
      this.isLoading = true;
      if (!this.slide) {
        return;
      }

      return this.$store
        .dispatch(UPDATE_ACTIVE_INTERACTION, {
          to: {
            asset: this.slide._id,
            withReturnButton: this.withReturnButton,
            withPagination: this.withPagination,
            return: {
              to: this.returnSlide.to ? this.returnSlide.to._id : null
            }
          },
          info: this.info || '',
          type: this.type
        })
        .then(() => {
          this.$emit('close');
          this.isLoading = false;
          this.slide = null;
          this.slides = [];
          this.type = 'click';
          this.returnSlide.to = null;
          this.wildcard = null;
          this.info = null;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    createInteraction() {
      this.isLoading = true;
      if (!this.slide) {
        return (this.isLoading = false);
      }
      this.$store
        .dispatch(CREATE_INTERACTION, {
          to: {
            asset: this.slide._id,
            withReturnButton: this.withReturnButton,
            withPagination: this.withPagination,

            return: {
              to: this.returnSlide.to ? this.returnSlide.to._id : null
            }
          },
          info: this.info || '',
          type: this.type
        })
        .then(result => {
          this.$emit('close');
          this.isLoading = false;
          this.slide = null;
          this.slides = [];
          this.type = 'click';
          this.returnSlide.to = null;
          this.wildcard = null;
          this.info = null;
        })
        .catch(e => {
          this.isLoading = false;
        });
    }
  }
};
</script>

<style scoped>
.new-interaction {
  border: 1px solid rgba(0, 0, 0, 0.12);
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
}

.img {
  border-radius: 5px;
  min-width: 300px;
  height: 100%;
  max-height: 100%;
  overflow-y: scroll;
}

.top {
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.card {
  max-width: 400px;
  min-width: 400px;
  height: 100%;
}

.slide-list {
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-bottom-right-radius: 5px;
  border-bottom-left-radius: 5px;
  margin-top: -1px;
}

.chip {
  text-align: center;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 50%;
  color: white;
  width: 20px !important;
  height: 20px !important;
  flex: none !important;
}

.connection-select {
  border-radius: 5px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  text-align: center !important;
  background-color: var(--Light-grey1);
}

.to-slide {
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  width: 100%;
  outline: none;
  border: 1px solid rgba(0, 0, 0, 0.12);
}
</style>
